import React from 'react';
import wb0 from '../img/Detail/watsons-detail.jpg';
import './Detail.css';
const WatsonsDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Watsons X MJCare Collaboration" />
    </div>
    
  );
};

export default WatsonsDetail;